/********************************************************************************
 * Copyright (c) 2020 Cedalo AG
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const dataprovider = require('./dataprovider');
const map = require('./map');
const properties = require('./properties');

module.exports = {
	...dataprovider,
	...map,
	...properties
};



// WEBPACK FOOTER //
// ../jsg-core/src/graph/model/utils/index.js